// src/lib/imageDimensions.ts
// Created for remote images when using Next.js's Image: https://nextjs.org/docs/app/getting-started/images#remote-images
export const imageDimensions = {
  "icons/AIC Logo.png": { width: 465, height: 342 },
  "icons/AIG Logo.png": { width: 424, height: 200 },
  "icons/Allstate Logo.png": { width: 4000, height: 942 },
  "icons/Allstate Logo.webp": { width: 1919, height: 452 },
  "icons/American Modern Logo.png": { width: 2700, height: 756 },
  "icons/American Modern Logo.webp": { width: 1920, height: 538 },
  "icons/Amwins Logo.png": { width: 549, height: 92 },
  "icons/Arbour Insurance Logo.png": { width: 1750, height: 627 },
  "icons/Arrow.png": { width: 172, height: 68 },
  "icons/Auto-Insurance.png": { width: 307, height: 182 },
  "icons/Auto-Insurance.webp": { width: 307, height: 182 },
  "icons/Auto-Owners Logo.png": { width: 485, height: 104 },
  "icons/BMW logo.png": { width: 500, height: 500 },
  "icons/Black - Shield and House.png": { width: 153, height: 183 },
  "icons/Black - Stacked.png": { width: 471, height: 183 },
  "icons/Blue - Shield and House.png": { width: 200, height: 200 },
  "icons/Blue-OneLine.png": { width: 1688, height: 261 },
  "icons/Blue-OneLine.webp": { width: 1688, height: 261 },
  "icons/Blue-Stacked.png": { width: 471, height: 183 },
  "icons/Blue-Stacked.webp": { width: 471, height: 183 },
  "icons/Bundle-Icon-Transparent.png": { width: 522, height: 413 },
  "icons/Bundle-Icon-Transparent.webp": { width: 522, height: 413 },
  "icons/CRC Group Logo.png": { width: 1521, height: 266 },
  "icons/Carrier Comparison Design.jpg": { width: 14534, height: 10667 },
  "icons/Carrier Comparison Design.webp": { width: 1920, height: 1409 },
  "icons/Carrier Comparison on Phone.png": { width: 1079, height: 2079 },
  "icons/Carrier Comparison on Phone.webp": { width: 996, height: 1919 },
  "icons/Check Circle Blue.png": { width: 74, height: 74 },
  "icons/Check Circle Yellow.png": { width: 74, height: 74 },
  "icons/Chubb-Logo.png": { width: 3034, height: 307 },
  "icons/Chubb-Logo.webp": { width: 1917, height: 194 },
  "icons/Cincinnati Insurance Logo.png": { width: 362, height: 184 },
  "icons/Clock.png": { width: 363, height: 364 },
  "icons/Computer Screen - Kristi for homepage mockup.png": { width: 10924, height: 8696 },
  "icons/Computer Screen - Kristi for homepage mockup.webp": { width: 1919, height: 1528 },
  "icons/Computer Screen - yearly reshopping.png": { width: 10924, height: 8696 },
  "icons/Computer Screen - yearly reshopping.webp": { width: 1919, height: 1528 },
  "icons/Computer.png": { width: 278, height: 220 },
  "icons/Corner-Shield.png": { width: 1144, height: 1462 },
  "icons/Corner-Shield.webp": { width: 1144, height: 1462 },
  "icons/Encova Insurance Logo.png": { width: 470, height: 124 },
  "icons/Erie Insurance Logo.png": { width: 450, height: 177 },
  "icons/Farmers Insurance Logo.png": { width: 3840, height: 822 },
  "icons/Farmers Insurance Logo.webp": { width: 1920, height: 411 },
  "icons/First Acceptance Logo.png": { width: 370, height: 132 },
  "icons/Foremost-Logo.png": { width: 1024, height: 260 },
  "icons/Frontline Insurance Logo.png": { width: 400, height: 101 },
  "icons/GS Branded Location Pin.png": { width: 712, height: 1268 },
  "icons/Glassdoor_Logo.webp": { width: 1920, height: 576 },
  "icons/Guardian Marketplace Screenshot.png": { width: 10924, height: 8696 },
  "icons/Guardian Marketplace Screenshot.webp": { width: 1919, height: 1528 },
  "icons/Hagerty Insurance Logo.png": { width: 3000, height: 1000 },
  "icons/Hagerty Insurance Logo.webp": { width: 1920, height: 640 },
  "icons/Heritage Insurance Logo.png": { width: 1000, height: 215 },
  "icons/Hero image - man and phone.png": { width: 3154, height: 2476 },
  "icons/Hero image - man and phone.webp": { width: 1920, height: 1507 },
  "icons/Home & Auto Bundle.png": { width: 2089, height: 1652 },
  "icons/Home & Auto Bundle.webp": { width: 1920, height: 1518 },
  "icons/Home Illustration with Shield Overlay.png": { width: 2578, height: 1010 },
  "icons/Home Illustration with Shield Overlay.webp": { width: 1919, height: 752 },
  "icons/Home-Insurance.png": { width: 277, height: 254 },
  "icons/Home-Insurance.webp": { width: 277, height: 254 },
  "icons/Homeowners of America Logo.png": { width: 1425, height: 375 },
  "icons/Icon - Auto.png": { width: 963, height: 607 },
  "icons/Icon - Boat.png": { width: 965, height: 753 },
  "icons/Icon - Burglar Alarm.png": { width: 751, height: 796 },
  "icons/Icon - Commission-Free.png": { width: 5739, height: 5706 },
  "icons/Icon - Commission-Free.webp": { width: 1920, height: 1909 },
  "icons/Icon - Condo.png": { width: 726, height: 918 },
  "icons/Icon - Deadbolt Lock.png": { width: 590, height: 844 },
  "icons/Icon - Energize & Engage.png": { width: 574, height: 701 },
  "icons/Icon - Expect Excellence.png": { width: 354, height: 329 },
  "icons/Icon - Fire Sprinkler.png": { width: 931, height: 719 },
  "icons/Icon - Gated Community.png": { width: 1039, height: 845 },
  "icons/Icon - Home & Auto.png": { width: 1332, height: 1405 },
  "icons/Icon - Home.png": { width: 961, height: 844 },
  "icons/Icon - Motorcycle.png": { width: 1001, height: 621 },
  "icons/Icon - Other Products.png": { width: 748, height: 645 },
  "icons/Icon - Pool.png": { width: 8986, height: 7762 },
  "icons/Icon - Pool.webp": { width: 1919, height: 1658 },
  "icons/Icon - Reach for Results.png": { width: 265, height: 224 },
  "icons/Icon - Renters.png": { width: 782, height: 833 },
  "icons/Icon - Serve Others.png": { width: 261, height: 203 },
  "icons/Icon - Smoke Detector.png": { width: 844, height: 748 },
  "icons/Icon - Trampoline.png": { width: 1096, height: 664 },
  "icons/Icon - Umbrella.png": { width: 729, height: 734 },
  "icons/Icon - Value Growth.png": { width: 229, height: 273 },
  "icons/Icon - Water Leak Detection.png": { width: 733, height: 777 },
  "icons/Indeed_Logo.webp": { width: 1920, height: 517 },
  "icons/Insurance Concierge.png": { width: 2101, height: 2234 },
  "icons/Insurance Concierge.webp": { width: 1806, height: 1920 },
  "icons/Jewelers Mutual Logo.png": { width: 867, height: 290 },
  "icons/Johnson and Johnson Logo.png": { width: 587, height: 93 },
  "icons/Kawasaki logo.webp": { width: 2000, height: 2000 },
  "icons/Lemonade Logo.png": { width: 664, height: 172 },
  "icons/Liability Insurance.png": { width: 251, height: 252 },
  "icons/Liberty-Mutual-Logo.png": { width: 2388, height: 656 },
  "icons/Liberty-Mutual-Logo.webp": { width: 1918, height: 527 },
  "icons/LinkedIn_Logo.webp": { width: 1920, height: 480 },
  "icons/Location Pin with Logo.png": { width: 1877, height: 2325 },
  "icons/Location Pin with Logo.webp": { width: 1550, height: 1920 },
  "icons/Location Pin.png": { width: 45, height: 70 },
  "icons/NC Map.png": { width: 7106, height: 2701 },
  "icons/NC Map.webp": { width: 1920, height: 730 },
  "icons/Nat Gen Logo.png": { width: 762, height: 351 },
  "icons/National-General-Logo.png": { width: 762, height: 351 },
  "icons/Nationwide-Logo.png": { width: 3840, height: 1548 },
  "icons/Nationwide-Logo.webp": { width: 1920, height: 774 },
  "icons/Navy - Shield and House.png": { width: 153, height: 183 },
  "icons/Neptune Insurance Logo.png": { width: 5286, height: 1394 },
  "icons/Neptune Insurance Logo.webp": { width: 1919, height: 506 },
  "icons/New Challenger Page Hero Image.png": { width: 2837, height: 3062 },
  "icons/New Challenger Page Hero Image.webp": { width: 1779, height: 1920 },
  "icons/Orchid Insurance Logo.png": { width: 2299, height: 605 },
  "icons/Orchid Insurance Logo.webp": { width: 1919, height: 505 },
  "icons/Orion Logo.png": { width: 800, height: 208 },
  "icons/Palomar Insurance Logo.png": { width: 1920, height: 330 },
  "icons/Phone.png": { width: 1024, height: 1747 },
  "icons/Piggy Bank.png": { width: 465, height: 334 },
  "icons/Plus Icon - new.png": { width: 373, height: 388 },
  "icons/Positive Energy.png": { width: 232, height: 215 },
  "icons/Progressive-logo.png": { width: 3840, height: 600 },
  "icons/Progressive-logo.webp": { width: 1920, height: 300 },
  "icons/Pure Insurance Logo.png": { width: 2157, height: 1129 },
  "icons/Pure Insurance Logo.webp": { width: 1920, height: 1005 },
  "icons/Risk IQ Screenshot.png": { width: 10924, height: 8696 },
  "icons/Risk IQ Screenshot.webp": { width: 1919, height: 1528 },
  "icons/Row of Blue Houses.jpg": { width: 2446, height: 629 },
  "icons/Row of Blue Houses.webp": { width: 1920, height: 494 },
  "icons/Row of Yellow Houses.jpg": { width: 2446, height: 629 },
  "icons/Row of Yellow Houses.webp": { width: 1920, height: 494 },
  "icons/Safeco Insurance Logo.png": { width: 2446, height: 667 },
  "icons/Safeco Insurance Logo.webp": { width: 1920, height: 524 },
  "icons/Shield with Checkmark.png": { width: 316, height: 318 },
  "icons/Shield with House.png": { width: 505, height: 623 },
  "icons/Specialty-Insurance.png": { width: 501, height: 534 },
  "icons/Specialty-Insurance.webp": { width: 501, height: 534 },
  "icons/Star Icon.webp": { width: 86, height: 82 },
  "icons/Star.png": { width: 360, height: 343 },
  "icons/Steadily Logo.png": { width: 560, height: 82 },
  "icons/Stillwater Logo.png": { width: 500, height: 131 },
  "icons/Target.png": { width: 431, height: 367 },
  "icons/The Hartford logo.png": { width: 770, height: 166 },
  "icons/Travelers.png": { width: 3840, height: 888 },
  "icons/Travelers.webp": { width: 1920, height: 444 },
  "icons/Trophy.png": { width: 336, height: 365 },
  "icons/Underline - navy.png": { width: 391, height: 64 },
  "icons/Underline - white.png": { width: 388, height: 58 },
  "icons/Underline.png": { width: 388, height: 58 },
  "icons/Universal-Logo.png": { width: 461, height: 109 },
  "icons/Updated Hero Image - Woman on Phone - V2.png": { width: 2544, height: 3744 },
  "icons/Updated Hero Image - Woman on Phone - V2.webp": { width: 1305, height: 1920 },
  "icons/Utility Line Warranty.png": { width: 248, height: 248 },
  "icons/White - One Line.png": { width: 1688, height: 261 },
  "icons/White - Stacked.png": { width: 472, height: 183 },
  "icons/Woman Looking at Phone.png": { width: 2624, height: 2542 },
  "icons/Woman Looking at Phone.webp": { width: 1920, height: 1860 },
  "icons/Yellow - Shield Only - Square.png": { width: 635, height: 635 },
  "icons/Yellow - Shield Only.png": { width: 506, height: 635 },
  "icons/Yellow and White - Shield and House.png": { width: 154, height: 183 },
  "icons/Yellow and White - Stacked.png": { width: 472, height: 183 },
  "icons/allied-logo.webp": { width: 256, height: 256 },
  "icons/auto-navy.webp": { width: 963, height: 607 },
  "icons/bamboo-logo.webp": { width: 576, height: 108 },
  "icons/bbb-grey.webp": { width: 1844, height: 699 },
  "icons/beneteau.webp": { width: 180, height: 180 },
  "icons/boat-insurance.webp": { width: 756, height: 396 },
  "icons/boat-navy.webp": { width: 965, height: 753 },
  "icons/boston-whaler.webp": { width: 2560, height: 542 },
  "icons/burglar-alarm-navy.webp": { width: 751, height: 796 },
  "icons/check-circle-blue.webp": { width: 74, height: 74 },
  "icons/check-circle-yellow.png": { width: 74, height: 74 },
  "icons/check-circle-yellow.webp": { width: 74, height: 74 },
  "icons/condo-navy.webp": { width: 726, height: 918 },
  "icons/deadbolt-lock-navy.webp": { width: 590, height: 844 },
  "icons/ducati.webp": { width: 965, height: 1024 },
  "icons/fire-sprinkler-navy.webp": { width: 931, height: 719 },
  "icons/formula.webp": { width: 600, height: 600 },
  "icons/gated-community-navy.webp": { width: 1039, height: 845 },
  "icons/grady-white.webp": { width: 400, height: 159 },
  "icons/guardian-service-logo-white.webp": { width: 1688, height: 261 },
  "icons/harley-davidson.webp": { width: 320, height: 320 },
  "icons/home-auto-navy.webp": { width: 1332, height: 1405 },
  "icons/home-navy.webp": { width: 961, height: 844 },
  "icons/icon-always-on-shopping.webp": { width: 392, height: 392 },
  "icons/icon-buy-it-your-way.webp": { width: 247, height: 180 },
  "icons/icon-clock-2.webp": { width: 363, height: 364 },
  "icons/icon-commissions.webp": { width: 1920, height: 1915 },
  "icons/icon-computer-2.webp": { width: 278, height: 220 },
  "icons/icon-customization.webp": { width: 431, height: 367 },
  "icons/icon-energize-engage.webp": { width: 574, height: 701 },
  "icons/icon-expect-excellence.webp": { width: 354, height: 329 },
  "icons/icon-no-hidden-fees-v2.webp": { width: 352, height: 401 },
  "icons/icon-no-hidden-fees.webp": { width: 149, height: 176 },
  "icons/icon-our-promise.webp": { width: 1920, height: 1381 },
  "icons/icon-quick-and-easy-new.webp": { width: 1920, height: 1833 },
  "icons/icon-reach-for-results.webp": { width: 265, height: 224 },
  "icons/icon-serious-savings.webp": { width: 465, height: 334 },
  "icons/icon-serve-others.webp": { width: 261, height: 203 },
  "icons/icon-value-growth.webp": { width: 229, height: 273 },
  "icons/indian.webp": { width: 3840, height: 2160 },
  "icons/investment-properties.webp": { width: 209, height: 175 },
  "icons/jewelry-insurance.webp": { width: 445, height: 525 },
  "icons/kawasaki.webp": { width: 2000, height: 2000 },
  "icons/liability-insurance.webp": { width: 251, height: 252 },
  "icons/motorcycle-insurance.webp": { width: 188, height: 104 },
  "icons/motorcycle-navy.webp": { width: 1001, height: 621 },
  "icons/other-products-navy.webp": { width: 748, height: 645 },
  "icons/pool.webp": { width: 1920, height: 1658 },
  "icons/renters-navy.webp": { width: 782, height: 833 },
  "icons/safe-icon-white-2.png": { width: 368, height: 397 },
  "icons/sea-ray.webp": { width: 320, height: 320 },
  "icons/secure-computer-icon.webp": { width: 599, height: 521 },
  "icons/secure.webp": { width: 1430, height: 513 },
  "icons/shield-with-house.webp": { width: 505, height: 623 },
  "icons/shield-yellow-white.webp": { width: 154, height: 183 },
  "icons/smoke-detector-navy.webp": { width: 844, height: 748 },
  "icons/sun-tracker.webp": { width: 1130, height: 407 },
  "icons/testimonial-sontice.png": { width: 1168, height: 1168 },
  "icons/thumbs-up-yellow.png": { width: 354, height: 329 },
  "icons/thumbs-up-yellow.webp": { width: 354, height: 329 },
  "icons/tracker.webp": { width: 3000, height: 968 },
  "icons/trampoline.webp": { width: 1096, height: 664 },
  "icons/triumph.webp": { width: 640, height: 480 },
  "icons/umbrella-icon.webp": { width: 1067, height: 1067 },
  "icons/umbrella-navy.webp": { width: 729, height: 734 },
  "icons/water-leak-navy.webp": { width: 177, height: 187 },
  "icons/yamaha.webp": { width: 3840, height: 2160 },
  "images/5-stars.webp": { width: 379, height: 87 },
  "images/AAA_Insurance_Logo.webp": { width: 397, height: 180 },
  "images/AI - John on computer.png": { width: 864, height: 1184 },
  "images/AI - John on computer.webp": { width: 864, height: 1184 },
  "images/AI - Kristi with mug.png": { width: 1632, height: 640 },
  "images/AI - Kristi with mug.webp": { width: 1632, height: 640 },
  "images/AIG_Logo-2.webp": { width: 424, height: 200 },
  "images/Agent 3x3 - blue color palette.jpg": { width: 10898, height: 10898 },
  "images/Agent 3x3 - blue color palette.png": { width: 10898, height: 10898 },
  "images/Agent 3x3 - blue color palette.webp": { width: 1920, height: 1920 },
  "images/Agent_Happy_Hour.webp": { width: 5712, height: 4284 },
  "images/Allied_Trust_Logo.webp": { width: 256, height: 256 },
  "images/Allstate_Logo.webp": { width: 1920, height: 452 },
  "images/American_Integrity_Logo.webp": { width: 877, height: 229 },
  "images/American_Modern_Logo.webp": { width: 700, height: 400 },
  "images/Amwins_Logo.webp": { width: 549, height: 92 },
  "images/Arbour_Insurance_Logo.webp": { width: 1750, height: 627 },
  "images/BBB_Badge.png": { width: 864, height: 350 },
  "images/BBB_Badge.webp": { width: 864, height: 350 },
  "images/BMW.webp": { width: 2496, height: 2496 },
  "images/Bamboo_Insurance_Logo.webp": { width: 2406, height: 537 },
  "images/Bear_River_Mutual_Logo.webp": { width: 500, height: 165 },
  "images/Branch_Logo.webp": { width: 700, height: 256 },
  "images/CRC_Group_Logo.webp": { width: 1521, height: 266 },
  "images/Chevrolet.webp": { width: 3840, height: 3840 },
  "images/Chubb_Logo.webp": { width: 1920, height: 194 },
  "images/Clearcover_Logo.webp": { width: 700, height: 400 },
  "images/Consumer_Affairs_Logo.png": { width: 900, height: 162 },
  "images/Consumer_Affairs_Logo.webp": { width: 900, height: 162 },
  "images/Dairyland_Insurance.webp": { width: 708, height: 178 },
  "images/Dodge.webp": { width: 563, height: 563 },
  "images/Estelle-original-original.webp": { width: 2933, height: 2933 },
  "images/Estelle-original.webp": { width: 733, height: 733 },
  "images/Estelle.jpg": { width: 2933, height: 2933 },
  "images/Estelle.webp": { width: 1920, height: 1920 },
  "images/Farmers_Insurance_Logo.webp": { width: 1920, height: 411 },
  "images/Fingerprint.jpeg": { width: 8290, height: 2088 },
  "images/Fingerprint.webp": { width: 1920, height: 484 },
  "images/Ford.webp": { width: 1024, height: 412 },
  "images/Foremost_Logo.webp": { width: 1024, height: 247 },
  "images/Frontline_Insurance_Logo.webp": { width: 1413, height: 299 },
  "images/GMC.webp": { width: 600, height: 162 },
  "images/Geico_Logo.webp": { width: 2560, height: 451 },
  "images/GeoVera_Logo.webp": { width: 1204, height: 505 },
  "images/Google 5 Stars - color.webp": { width: 1000, height: 133 },
  "images/Google 5 Stars - white.webp": { width: 1000, height: 133 },
  "images/Google_Logo.webp": { width: 1200, height: 406 },
  "images/Google_Reviews_Badge.png": { width: 769, height: 431 },
  "images/Google_Reviews_Badge.webp": { width: 769, height: 431 },
  "images/Grange_Insurance_Logo.webp": { width: 1063, height: 613 },
  "images/Habitat Photo - v2.jpg": { width: 2274, height: 1434 },
  "images/Habitat Photo - v2.webp": { width: 1920, height: 1211 },
  "images/Hagerty_Insurance_Logo.webp": { width: 1920, height: 640 },
  "images/Heath-and-Family-full-original.webp": { width: 3024, height: 4032 },
  "images/Heath-and-Family-full.jpg": { width: 3024, height: 4032 },
  "images/Heath-and-Family-full.webp": { width: 1440, height: 1920 },
  "images/Heritage_Insurance_Logo.webp": { width: 1000, height: 215 },
  "images/Homeowners_of_America_Logo.webp": { width: 1425, height: 375 },
  "images/Honda.webp": { width: 10000, height: 10000 },
  "images/Hyundai.webp": { width: 525, height: 295 },
  "images/Image - Local Professionals.jpg": { width: 1191, height: 673 },
  "images/Image - National Expertise.jpg": { width: 1194, height: 675 },
  "images/Image - Responsive Service.jpg": { width: 1200, height: 678 },
  "images/Jeep.webp": { width: 3000, height: 3000 },
  "images/Jeremy on call - for header.jpg": { width: 4284, height: 1716 },
  "images/Jeremy on call - for header.webp": { width: 1920, height: 769 },
  "images/Jeremy on call - redacted.png": { width: 3282, height: 3282 },
  "images/Jeremy on call - redacted.webp": { width: 1920, height: 1920 },
  "images/Jewelers_Mutual_Logo.webp": { width: 867, height: 290 },
  "images/Johnson_and_Johnson_Logo.webp": { width: 587, height: 93 },
  "images/Join Us - Full-Width Photo.jpg": { width: 2707, height: 608 },
  "images/Join Us - Full-Width Photo.webp": { width: 1919, height: 431 },
  "images/Join Us Image - 1.jpg": { width: 2821, height: 2821 },
  "images/Join Us Image - 1.webp": { width: 1920, height: 1920 },
  "images/Join Us Image - 2.jpg": { width: 4284, height: 4284 },
  "images/Join Us Image - 2.webp": { width: 1920, height: 1920 },
  "images/KIA.webp": { width: 10417, height: 2454 },
  "images/Kara and Jeff - higher res.png": { width: 1696, height: 608 },
  "images/Kara and Jeff - higher res.webp": { width: 1696, height: 608 },
  "images/Kara-and-Grant-full.jpg": { width: 828, height: 828 },
  "images/Kara-and-Grant-full.webp": { width: 828, height: 828 },
  "images/Kristi at computer - v2.JPG": { width: 3198, height: 1146 },
  "images/Kristi at computer - v2.webp": { width: 1920, height: 688 },
  "images/Kristi_on_Video.webp": { width: 5712, height: 4284 },
  "images/Lauren_and_Kara- 2.webp": { width: 4032, height: 3024 },
  "images/Leadership retreat - for hero.jpg": { width: 3924, height: 1284 },
  "images/Leadership retreat - for hero.webp": { width: 1919, height: 628 },
  "images/Lemonade_Logo.webp": { width: 664, height: 172 },
  "images/Liberty_Mutual_Logo.webp": { width: 1920, height: 527 },
  "images/Mapfre_Insurance_Logo.webp": { width: 367, height: 29 },
  "images/Mary-on-phone.png": { width: 864, height: 1184 },
  "images/Mary-on-phone.webp": { width: 864, height: 1184 },
  "images/Matching Employees - v2.jpg": { width: 3162, height: 1998 },
  "images/Matching Employees - v2.webp": { width: 1920, height: 1213 },
  "images/Meet Our Agents Picture.png": { width: 5280, height: 1932 },
  "images/Meet Our Agents Picture.webp": { width: 1920, height: 703 },
  "images/Member Benefits Image - Free Claims Concierge.jpeg": { width: 900, height: 506 },
  "images/Member Benefits Image - Free Claims Concierge.webp": { width: 900, height: 506 },
  "images/Member Benefits Image - Sewer Line Warranty.jpg": { width: 900, height: 506 },
  "images/Mercury_Insurance_Logo.webp": { width: 459, height: 110 },
  "images/Mutual_of_Enumclaw_Logo.webp": { width: 700, height: 213 },
  "images/National_General_Logo.webp": { width: 762, height: 351 },
  "images/Nationwide_Logo.webp": { width: 3840, height: 1548 },
  "images/Neptune_Insurance_Logo.webp": { width: 1920, height: 506 },
  "images/New About Us Image - full-width.JPG": { width: 1744, height: 620 },
  "images/New About Us Image - full-width.webp": { width: 1744, height: 620 },
  "images/New Hero Image for How It Works page.jpg": { width: 1996, height: 796 },
  "images/New Hero Image for How It Works page.webp": { width: 1920, height: 766 },
  "images/New Hero Image for Member Benefits - Kara.JPG": { width: 1912, height: 924 },
  "images/New Image for Member Benefits page.JPG": { width: 2008, height: 808 },
  "images/New Image for Member Benefits page.webp": { width: 1920, height: 773 },
  "images/New Image for Partnerships Page.JPG": { width: 2784, height: 1104 },
  "images/New Image for Partnerships Page.webp": { width: 1919, height: 761 },
  "images/Newsweek_Logo.png": { width: 792, height: 127 },
  "images/Newsweek_Logo.webp": { width: 792, height: 127 },
  "images/Nissan.webp": { width: 1907, height: 1633 },
  "images/Non-Stock Photo - 2.jpg": { width: 1642, height: 1642 },
  "images/Non-Stock Photo - 2.webp": { width: 1642, height: 1642 },
  "images/Non-Stock Photo - 3.jpg": { width: 3541, height: 3541 },
  "images/Non-Stock Photo - 3.webp": { width: 1920, height: 1920 },
  "images/Obie_Logo.webp": { width: 1000, height: 396 },
  "images/Office Image - 1.JPG": { width: 4215, height: 4215 },
  "images/Office Image - 1.webp": { width: 1920, height: 1920 },
  "images/Office Image - 2.JPG": { width: 4284, height: 4284 },
  "images/Office Image - 2.webp": { width: 1920, height: 1920 },
  "images/Office Image - 3.JPG": { width: 4000, height: 4000 },
  "images/Office Image - 3.webp": { width: 1920, height: 1920 },
  "images/Office Image - new 3.jpg": { width: 2981, height: 2981 },
  "images/Office Image - new 3.webp": { width: 1920, height: 1920 },
  "images/One_Alliance_Logo.webp": { width: 400, height: 143 },
  "images/Orchid_Insurance_Logo.webp": { width: 1920, height: 505 },
  "images/Orion_Logo.webp": { width: 800, height: 208 },
  "images/Palomar_Insurance_Logo.webp": { width: 1920, height: 330 },
  "images/Panorama - for auto insurance page.jpg": { width: 2747, height: 608 },
  "images/Panorama - for auto insurance page.webp": { width: 1920, height: 425 },
  "images/Penn_National_Logo.webp": { width: 689, height: 177 },
  "images/Peter-and-family-full.jpg": { width: 661, height: 443 },
  "images/Peter-and-family-full.webp": { width: 661, height: 443 },
  "images/Phone Screen - for full-width.jpg": { width: 8928, height: 2800 },
  "images/Phone Screen - for full-width.webp": { width: 1920, height: 602 },
  "images/Photo Wall - for full-width hero.jpg": { width: 4032, height: 1320 },
  "images/Photo Wall - for full-width hero.webp": { width: 1920, height: 629 },
  "images/Plus Icon - tighter crop.png": { width: 148, height: 138 },
  "images/Plymouth_Rock_Assurance_Logo.webp": { width: 700, height: 200 },
  "images/Progressive_Logo.webp": { width: 3840, height: 600 },
  "images/Pure_Insurance_Logo.webp": { width: 1920, height: 1004 },
  "images/RV Photo.jpeg": { width: 2747, height: 608 },
  "images/RV Photo.webp": { width: 1920, height: 425 },
  "images/Realtor_Logo.png": { width: 949, height: 190 },
  "images/Realtor_Logo.webp": { width: 949, height: 190 },
  "images/Reviews Hero Image.JPG": { width: 6000, height: 2068 },
  "images/Reviews Hero Image.webp": { width: 1920, height: 662 },
  "images/Root_Insurance_Logo.webp": { width: 320, height: 163 },
  "images/Row of Houses - full-width.jpg": { width: 2747, height: 608 },
  "images/Row of Houses - full-width.webp": { width: 1920, height: 425 },
  "images/Safeco_Insurance_Logo.webp": { width: 1920, height: 523 },
  "images/SageSure_Logo.webp": { width: 339, height: 151 },
  "images/Savvi_Logo.webp": { width: 397, height: 216 },
  "images/Shelter_Insurance_Logo.webp": { width: 560, height: 544 },
  "images/Sized photo of Kristi.png": { width: 10924, height: 8696 },
  "images/Sized photo of Kristi.webp": { width: 1919, height: 1528 },
  "images/Square - agents(1).png": { width: 3024, height: 3024 },
  "images/Square - agents(1).webp": { width: 1920, height: 1920 },
  "images/Square - agents.png": { width: 3024, height: 3024 },
  "images/Square - agents.webp": { width: 1920, height: 1920 },
  "images/Square - meeting.jpg": { width: 3024, height: 3024 },
  "images/Square - meeting.webp": { width: 1920, height: 1920 },
  "images/Square - team meeting.png": { width: 2160, height: 2160 },
  "images/Square - team meeting.webp": { width: 1920, height: 1920 },
  "images/States We Serve - for hero.JPG": { width: 4920, height: 1673 },
  "images/States We Serve - for hero.webp": { width: 1920, height: 653 },
  "images/Steadily_Logo.webp": { width: 560, height: 82 },
  "images/Stillwater_Logo.webp": { width: 500, height: 131 },
  "images/Swyfft_Logo.webp": { width: 600, height: 327 },
  "images/Testimonial Photo - Andrea Tysor.jpg": { width: 2728, height: 3024 },
  "images/Testimonial Photo - Andrea Tysor.webp": { width: 1732, height: 1920 },
  "images/Testimonial Photo - Diane Marrero.webp": { width: 1000, height: 1333 },
  "images/Testimonial Photo - Mike Caragher.jpg": { width: 480, height: 640 },
  "images/Testimonial Photo - Thomas McLaughlin.webp": { width: 500, height: 667 },
  "images/Thanksgiving_Photo.webp": { width: 4080, height: 3072 },
  "images/The_General_Logo.webp": { width: 430, height: 117 },
  "images/The_Hartford_Logo-2.webp": { width: 770, height: 166 },
  "images/The_Hartford_Logo.png": { width: 770, height: 166 },
  "images/Toyota.webp": { width: 3082, height: 1949 },
  "images/Travelers_Logo.webp": { width: 1920, height: 444 },
  "images/TWIA_Logo.webp": { width: 194, height: 238 },
  "images/TrustPilot_Badge.png": { width: 971, height: 661 },
  "images/TrustPilot_Badge.webp": { width: 971, height: 661 },
  "images/TrustPilot_Logo.webp": { width: 1920, height: 471 },
  "images/ULW - Clogs and Blockages.jpeg": { width: 800, height: 533 },
  "images/ULW - Ground Settling.jpeg": { width: 800, height: 533 },
  "images/ULW - Old Pipes.jpeg": { width: 800, height: 533 },
  "images/ULW - Rodents.jpeg": { width: 800, height: 533 },
  "images/ULW - Tree Roots.jpeg": { width: 800, height: 533 },
  "images/ULW - Weather Conditions.jpeg": { width: 800, height: 533 },
  "images/ULW Testimonial Headshot - Allen Foster.jpg": { width: 148, height: 148 },
  "images/ULW Testimonial Headshot - Kyle Patterson.jpg": { width: 500, height: 500 },
  "images/ULW Testimonial Headshot - Lauren Prosser.jpg": { width: 204, height: 204 },
  "images/ULW Testimonial Headshot - Molly OConnor.jpg": { width: 286, height: 286 },
  "images/ULW Testimonial Photo - Allen Foster.jpeg": { width: 677, height: 679 },
  "images/ULW Testimonial Photo - Kyle Patterson.jpg": { width: 1200, height: 1200 },
  "images/ULW Testimonial Photo - Lauren Prosser.jpeg": { width: 1200, height: 1195 },
  "images/ULW Testimonial Photo - Molly OConnor.jpeg": { width: 1224, height: 1282 },
  "images/USA_Today_Logo.png": { width: 1920, height: 288 },
  "images/USA_Today_Logo.webp": { width: 1920, height: 288 },
  "images/Universal_Insurance_Logo-2.webp": { width: 600, height: 200 },
  "images/Updated Meet Our Agents Photo.JPG": { width: 2092, height: 896 },
  "images/Updated Meet Our Agents Photo.webp": { width: 1919, height: 822 },
  "images/WRAL-interview.jpg": { width: 599, height: 599 },
  "images/WRAL-interview.webp": { width: 599, height: 599 },
  "images/Washington_Post_Logo.png": { width: 1920, height: 299 },
  "images/Washington_Post_Logo.webp": { width: 1920, height: 299 },
  "images/Wellington_Logo.webp": { width: 490, height: 103 },
  "images/West_Bend_Logo.webp": { width: 2084, height: 589 },
  "images/Westfield_Logo.webp": { width: 500, height: 230 },
  "images/White Wall - For Hero Image.jpg": { width: 4002, height: 1360 },
  "images/White Wall - For Hero Image.webp": { width: 1919, height: 652 },
  "images/about-hero-new-2.webp": { width: 1696, height: 608 },
  "images/about/about-hero-new-2.webp": { width: 1696, height: 608 },
  "images/about/about-hero-new-5.webp": { width: 1920, height: 622 },
  "images/about/about-photo-1.webp": { width: 1732, height: 1732 },
  "images/about/about-photo-2.webp": { width: 1642, height: 1642 },
  "images/about/about-photo-3.webp": { width: 1824, height: 1824 },
  "images/about/al-county-map.webp": { width: 1226, height: 1920 },
  "images/about/al-flag-hero.webp": { width: 1920, height: 1319 },
  "images/about/al-homeowners-know.webp": { width: 1281, height: 1920 },
  "images/about/al-photo-1.webp": { width: 1920, height: 1920 },
  "images/about/al-photo-2.webp": { width: 1920, height: 1331 },
  "images/about/al-photo-3.webp": { width: 1920, height: 1280 },
  "images/about/al-photo-4.webp": { width: 1920, height: 1281 },
  "images/about/al-photo-5.webp": { width: 800, height: 600 },
  "images/about/al-photo-6.webp": { width: 1920, height: 1080 },
  "images/about/az-county-map.webp": { width: 1658, height: 1920 },
  "images/about/az-flag-hero.webp": { width: 1920, height: 1344 },
  "images/about/az-homeowners-know.webp": { width: 1290, height: 1824 },
  "images/about/az-photo-1.webp": { width: 1920, height: 1280 },
  "images/about/az-photo-2.webp": { width: 1920, height: 1280 },
  "images/about/az-photo-3.webp": { width: 1920, height: 1440 },
  "images/about/az-photo-4.webp": { width: 1920, height: 1280 },
  "images/about/az-photo-5.webp": { width: 1920, height: 1322 },
  "images/about/az-photo-6.webp": { width: 1824, height: 1224 },
  "images/about/canopy.webp": { width: 567, height: 478 },
  "images/about/co-county-map.webp": { width: 1920, height: 1317 },
  "images/about/co-flag-hero.webp": { width: 1920, height: 1319 },
  "images/about/co-homeowners-know.webp": { width: 1000, height: 1500 },
  "images/about/co-photo-1.webp": { width: 1920, height: 1280 },
  "images/about/co-photo-2.webp": { width: 1920, height: 1280 },
  "images/about/co-photo-3.webp": { width: 1920, height: 1440 },
  "images/about/co-photo-4.webp": { width: 1920, height: 1277 },
  "images/about/co-photo-5.webp": { width: 800, height: 800 },
  "images/about/co-photo-6.webp": { width: 1824, height: 1215 },
  "images/about/ct-county-map.webp": { width: 1920, height: 1396 },
  "images/about/ct-flag-hero.webp": { width: 1920, height: 1920 },
  "images/about/ct-homeowners-know.webp": { width: 1216, height: 1824 },
  "images/about/ct-photo-1.webp": { width: 1920, height: 1080 },
  "images/about/ct-photo-2.webp": { width: 1920, height: 1280 },
  "images/about/ct-photo-3.webp": { width: 1920, height: 1280 },
  "images/about/ct-photo-4.webp": { width: 1920, height: 1280 },
  "images/about/ct-photo-5.webp": { width: 1024, height: 768 },
  "images/about/ct-photo-6.webp": { width: 1024, height: 701 },
  "images/about/customer-estelle-new.webp": { width: 4974, height: 6185 },
  "images/about/customer-estelle.webp": { width: 1524, height: 1920 },
  "images/about/customer-heath-family.webp": { width: 1447, height: 1824 },
  "images/about/customer-kara-family.webp": { width: 1524, height: 1920 },
  "images/about/customer-michael-family.webp": { width: 1544, height: 1920 },
  "images/about/customer-sontice-family.webp": { width: 4974, height: 6185 },
  "images/about/ga-atlanta-skyline.webp": { width: 1824, height: 1216 },
  "images/about/ga-county-map.webp": { width: 1021, height: 1215 },
  "images/about/ga-photo-1.webp": { width: 1920, height: 1276 },
  "images/about/ga-photo-2.webp": { width: 1920, height: 1440 },
  "images/about/ga-photo-3.webp": { width: 1920, height: 1280 },
  "images/about/ga-photo-4.webp": { width: 1920, height: 1495 },
  "images/about/ga-photo-5.webp": { width: 1824, height: 1302 },
  "images/about/ga-photo-6.webp": { width: 1824, height: 1216 },
  "images/about/in-country-map.webp": { width: 1251, height: 1920 },
  "images/about/in-flag-hero.webp": { width: 1920, height: 1319 },
  "images/about/in-homeowners-know.webp": { width: 1216, height: 1824 },
  "images/about/in-photo-1.webp": { width: 1920, height: 1307 },
  "images/about/in-photo-2.webp": { width: 1920, height: 1213 },
  "images/about/in-photo-3.webp": { width: 1920, height: 1280 },
  "images/about/in-photo-4.webp": { width: 1920, height: 1280 },
  "images/about/in-photo-5.webp": { width: 1920, height: 1214 },
  "images/about/in-photo-6.webp": { width: 1920, height: 1376 },
  "images/about/kristi-cta-photo.webp": { width: 1998, height: 1998 },
  "images/about/kristi-working.webp": { width: 1920, height: 1528 },
  "images/about/ky-country-map.webp": { width: 1920, height: 828 },
  "images/about/ky-flag-hero.webp": { width: 1920, height: 1280 },
  "images/about/ky-homeowners-know.webp": { width: 1118, height: 1824 },
  "images/about/ky-photo-1.webp": { width: 1920, height: 1440 },
  "images/about/ky-photo-2.webp": { width: 1920, height: 1272 },
  "images/about/ky-photo-3.webp": { width: 1920, height: 1440 },
  "images/about/ky-photo-4.webp": { width: 1920, height: 1280 },
  "images/about/ky-photo-5.webp": { width: 1920, height: 1078 },
  "images/about/ky-photo-6.webp": { width: 1920, height: 1280 },
  "images/about/leader-billy-gerhard.webp": { width: 1524, height: 1920 },
  "images/about/leader-carlos-patino.webp": { width: 1524, height: 1920 },
  "images/about/leader-chap-michie.webp": { width: 1524, height: 1920 },
  "images/about/leader-dana-wallace.webp": { width: 1524, height: 1920 },
  "images/about/leader-david-spitz.webp": { width: 1000, height: 1259 },
  "images/about/leader-elizabeth-bunn.webp": { width: 1524, height: 1920 },
  "images/about/leader-ellie-smith.webp": { width: 1524, height: 1920 },
  "images/about/leader-evan-burns.webp": { width: 1000, height: 1259 },
  "images/about/leader-gavin-polizzo.webp": { width: 1000, height: 1259 },
  "images/about/leader-heath-bradbury.webp": { width: 1524, height: 1920 },
  "images/about/leader-jack-rodriguez.webp": { width: 1524, height: 1920 },
  "images/about/leader-jackson-waller.webp": { width: 1524, height: 1920 },
  "images/about/leader-jeff-boyer.webp": { width: 1524, height: 1920 },
  "images/about/leader-jeremy-chasak.webp": { width: 1000, height: 1259 },
  "images/about/leader-joan-pierce.webp": { width: 1524, height: 1920 },
  "images/about/leader-john-clayton.webp": { width: 1524, height: 1920 },
  "images/about/leader-john-thornton.webp": { width: 1524, height: 1920 },
  "images/about/leader-jonathan-ruggiero.webp": { width: 1524, height: 1920 },
  "images/about/leader-kara-credle.webp": { width: 1524, height: 1920 },
  "images/about/leader-kristi-ware.webp": { width: 1524, height: 1920 },
  "images/about/leader-lacy-martin.webp": { width: 1000, height: 1259 },
  "images/about/leader-lauren-schwenk.webp": { width: 1447, height: 1824 },
  "images/about/leader-lindsey-yannoni.webp": { width: 1000, height: 1259 },
  "images/about/leader-liz-galarza.webp": { width: 1000, height: 1259 },
  "images/about/leader-luke-mitchell.webp": { width: 1000, height: 1259 },
  "images/about/leader-marc-gross.webp": { width: 1000, height: 1259 },
  "images/about/leader-mary-hahn.webp": { width: 1524, height: 1920 },
  "images/about/leader-mike-caragher.webp": { width: 1524, height: 1920 },
  "images/about/leader-mike-schmitt.webp": { width: 1000, height: 1259 },
  "images/about/leader-mike-stahl.webp": { width: 1524, height: 1920 },
  "images/about/leader-mitch-stella.webp": { width: 1000, height: 1259 },
  "images/about/leader-molly-oconnor.webp": { width: 1000, height: 1259 },
  "images/about/leader-patrick-fedroff.webp": { width: 1000, height: 1259 },
  "images/about/leader-peter-kerr.webp": { width: 1524, height: 1920 },
  "images/about/leader-peyton-helou.webp": { width: 1000, height: 1259 },
  "images/about/leader-rasesh-patel.webp": { width: 1000, height: 1259 },
  "images/about/leader-seth-garff.webp": { width: 1524, height: 1920 },
  "images/about/leader-sierra-dodds.webp": { width: 1000, height: 1259 },
  "images/about/leader-tommy-noles.webp": { width: 500, height: 630 },
  "images/about/leader-walker-fuller.webp": { width: 1524, height: 1920 },
  "images/about/leader-zach-clayton.webp": { width: 1524, height: 1920 },
  "images/about/leadership-hero.webp": { width: 1920, height: 628 },
  "images/about/md-county-map.webp": { width: 1920, height: 977 },
  "images/about/md-photo-1.webp": { width: 1920, height: 1281 },
  "images/about/md-photo-2.webp": { width: 1920, height: 1280 },
  "images/about/md-photo-3.webp": { width: 724, height: 648 },
  "images/about/md-photo-4.webp": { width: 1371, height: 1920 },
  "images/about/md-photo-5.webp": { width: 1920, height: 1279 },
  "images/about/md-photo-6.webp": { width: 1920, height: 1280 },
  "images/about/mn-country-map.webp": { width: 1763, height: 1920 },
  "images/about/mn-flag-hero.webp": { width: 1920, height: 1440 },
  "images/about/mn-homeowners-know.webp": { width: 1216, height: 1824 },
  "images/about/mn-photo-1.webp": { width: 1920, height: 1440 },
  "images/about/mn-photo-2.webp": { width: 1280, height: 1920 },
  "images/about/mn-photo-3.webp": { width: 1920, height: 1440 },
  "images/about/mn-photo-4.webp": { width: 1920, height: 1255 },
  "images/about/mn-photo-5.webp": { width: 1920, height: 1280 },
  "images/about/mn-photo-6.webp": { width: 1920, height: 1440 },
  "images/about/mo-county-map.webp": { width: 1742, height: 1556 },
  "images/about/mo-flag-hero.webp": { width: 1290, height: 1920 },
  "images/about/mo-homeowners-know.webp": { width: 1280, height: 1920 },
  "images/about/mo-photo-1.webp": { width: 1920, height: 1440 },
  "images/about/mo-photo-2.webp": { width: 1920, height: 1277 },
  "images/about/mo-photo-3.webp": { width: 1920, height: 1280 },
  "images/about/mo-photo-4.webp": { width: 1920, height: 1275 },
  "images/about/mo-photo-5.webp": { width: 1920, height: 1440 },
  "images/about/mo-photo-6.webp": { width: 1920, height: 1280 },
  "images/about/monitor.webp": { width: 1247, height: 993 },
  "images/about/ms-county-map.webp": { width: 1208, height: 1972 },
  "images/about/ms-flag-hero.webp": { width: 1920, height: 1920 },
  "images/about/ms-homeowners-know.webp": { width: 1000, height: 1350 },
  "images/about/ms-photo-1.webp": { width: 1920, height: 1526 },
  "images/about/ms-photo-2.webp": { width: 1024, height: 768 },
  "images/about/ms-photo-3.webp": { width: 800, height: 974 },
  "images/about/ms-photo-4.webp": { width: 1920, height: 1079 },
  "images/about/ms-photo-5.webp": { width: 1824, height: 1215 },
  "images/about/ms-photo-6.webp": { width: 667, height: 667 },
  "images/about/nc-county-map.webp": { width: 1920, height: 729 },
  "images/about/nc-flag-hero.webp": { width: 1920, height: 1310 },
  "images/about/nc-homeowners-know.webp": { width: 1824, height: 1026 },
  "images/about/nc-photo-1.webp": { width: 512, height: 512 },
  "images/about/nc-photo-2.webp": { width: 512, height: 512 },
  "images/about/nc-photo-3.webp": { width: 512, height: 512 },
  "images/about/nc-photo-4.webp": { width: 512, height: 512 },
  "images/about/nc-photo-5.webp": { width: 512, height: 512 },
  "images/about/nc-photo-6.webp": { width: 512, height: 512 },
  "images/about/nm-county-map-.webp": { width: 1920, height: 1920 },
  "images/about/nm-flag-hero.webp": { width: 1920, height: 1920 },
  "images/about/nm-homeowners-know.webp": { width: 1279, height: 1920 },
  "images/about/nm-photo-1.webp": { width: 1920, height: 1440 },
  "images/about/nm-photo-2.webp": { width: 1920, height: 1440 },
  "images/about/nm-photo-3.webp": { width: 1920, height: 1920 },
  "images/about/nm-photo-4.webp": { width: 1901, height: 1920 },
  "images/about/nm-photo-5.webp": { width: 1920, height: 1280 },
  "images/about/nm-photo-6.webp": { width: 1920, height: 1440 },
  "images/about/nv-country-map.webp": { width: 1299, height: 1920 },
  "images/about/nv-flag-hero.webp": { width: 1920, height: 1319 },
  "images/about/nv-homeowners-know.webp": { width: 1216, height: 1824 },
  "images/about/nv-photo-1.webp": { width: 1280, height: 720 },
  "images/about/nv-photo-2.webp": { width: 1920, height: 1280 },
  "images/about/nv-photo-3.webp": { width: 1280, height: 720 },
  "images/about/nv-photo-4.webp": { width: 1275, height: 1920 },
  "images/about/nv-photo-5.webp": { width: 1920, height: 1440 },
  "images/about/nv-photo-6.webp": { width: 1280, height: 1920 },
  "images/about/oh-country-map.webp": { width: 1773, height: 1920 },
  "images/about/oh-flag-hero.webp": { width: 1920, height: 1285 },
  "images/about/oh-homeowners-know.webp": { width: 1368, height: 1824 },
  "images/about/oh-photo-1.webp": { width: 1920, height: 1441 },
  "images/about/oh-photo-2.webp": { width: 1920, height: 1280 },
  "images/about/oh-photo-3.webp": { width: 1920, height: 1236 },
  "images/about/oh-photo-4.webp": { width: 1920, height: 1441 },
  "images/about/oh-photo-5.webp": { width: 1920, height: 1440 },
  "images/about/oh-photo-6.webp": { width: 1277, height: 1920 },
  "images/about/or-county-map.webp": { width: 1920, height: 1425 },
  "images/about/or-flag-hero.webp": { width: 1290, height: 1920 },
  "images/about/or-homeowners-know.webp": { width: 1000, height: 1500 },
  "images/about/or-photo-1.webp": { width: 1920, height: 1440 },
  "images/about/or-photo-2.webp": { width: 1920, height: 1283 },
  "images/about/or-photo-3.webp": { width: 1920, height: 1276 },
  "images/about/or-photo-4.webp": { width: 640, height: 480 },
  "images/about/or-photo-5.webp": { width: 1920, height: 1440 },
  "images/about/or-photo-6.webp": { width: 1920, height: 1759 },
  "images/about/origin-story-hero.webp": { width: 1920, height: 570 },
  "images/about/sc-city.webp": { width: 1920, height: 1279 },
  "images/about/sc-county-map.webp": { width: 525, height: 421 },
  "images/about/sc-fountain.webp": { width: 1920, height: 1281 },
  "images/about/sc-photo-1.webp": { width: 856, height: 802 },
  "images/about/sc-photo-2.webp": { width: 844, height: 804 },
  "images/about/sc-photo-3.webp": { width: 837, height: 795 },
  "images/about/sc-photo-4.webp": { width: 846, height: 802 },
  "images/about/sc-photo-5.webp": { width: 1824, height: 1024 },
  "images/about/state-flag-georgia.webp": { width: 1680, height: 1680 },
  "images/about/state-flag-maryland.webp": { width: 1920, height: 1920 },
  "images/about/state-flag-north-carolina.webp": { width: 1703, height: 1703 },
  "images/about/state-flag-south-carolina.webp": { width: 700, height: 700 },
  "images/about/state-flag-virginia.webp": { width: 1920, height: 1920 },
  "images/about/strip-georgia.webp": { width: 1824, height: 1824 },
  "images/about/strip-maryland.jpeg": { width: 1824, height: 1824 },
  "images/about/strip-maryland.webp": { width: 1824, height: 1824 },
  "images/about/strip-north-carolina.webp": { width: 1824, height: 1824 },
  "images/about/strip-south-carolina.webp": { width: 1824, height: 1824 },
  "images/about/strip-virginia.webp": { width: 1824, height: 1824 },
  "images/about/testimonial-elizabeth-bunn.webp": { width: 1000, height: 1333 },
  "images/about/testimonial-kara-credle.webp": { width: 1000, height: 1333 },
  "images/about/testimonial-lauren-schwenk.webp": { width: 1008, height: 1344 },
  "images/about/testimonial-luke-mitchell.webp": { width: 1000, height: 1333 },
  "images/about/testimonial-seth-garff.webp": { width: 1000, height: 1232 },
  "images/about/tn-county-map.webp": { width: 1920, height: 464 },
  "images/about/tn-flag-hero.webp": { width: 1024, height: 617 },
  "images/about/tn-homeowners-know.webp": { width: 1281, height: 1920 },
  "images/about/tn-photo-1.webp": { width: 1920, height: 1280 },
  "images/about/tn-photo-2.webp": { width: 1920, height: 1201 },
  "images/about/tn-photo-3.webp": { width: 1440, height: 1920 },
  "images/about/tn-photo-4.webp": { width: 1920, height: 1276 },
  "images/about/tn-photo-5.webp": { width: 1920, height: 1280 },
  "images/about/tn-photo-6.webp": { width: 1443, height: 1920 },
  "images/about/tx-county-map.webp": { width: 1920, height: 1789 },
  "images/about/tx-flag-hero.webp": { width: 1920, height: 1407 },
  "images/about/tx-homeowners-know.webp": { width: 1459, height: 1824 },
  "images/about/tx-photo-1.webp": { width: 1920, height: 1920 },
  "images/about/tx-photo-2.webp": { width: 1920, height: 1437 },
  "images/about/tx-photo-3.webp": { width: 1920, height: 1280 },
  "images/about/tx-photo-4.webp": { width: 1920, height: 1440 },
  "images/about/tx-photo-5.webp": { width: 1920, height: 1440 },
  "images/about/tx-photo-6.webp": { width: 1920, height: 1440 },
  "images/about/ut-country-map.webp": { width: 1275, height: 1593 },
  "images/about/ut-flag-hero.webp": { width: 1920, height: 1280 },
  "images/about/ut-homeowners-know.webp": { width: 1280, height: 1920 },
  "images/about/ut-photo-1.webp": { width: 1920, height: 1440 },
  "images/about/ut-photo-2.webp": { width: 1920, height: 1432 },
  "images/about/ut-photo-3.webp": { width: 1920, height: 1272 },
  "images/about/ut-photo-4.webp": { width: 1536, height: 1920 },
  "images/about/ut-photo-5.webp": { width: 1920, height: 1440 },
  "images/about/ut-photo-6.webp": { width: 1920, height: 1212 },
  "images/about/va-county-map.webp": { width: 1920, height: 839 },
  "images/about/va-photo-1.webp": { width: 1920, height: 1280 },
  "images/about/va-photo-2.webp": { width: 1920, height: 1440 },
  "images/about/va-photo-3.webp": { width: 556, height: 541 },
  "images/about/va-photo-4.webp": { width: 1920, height: 1271 },
  "images/about/va-photo-5.webp": { width: 1824, height: 1215 },
  "images/about/va-photo-6.webp": { width: 919, height: 880 },
  "images/about/wa-county-map.webp": { width: 1920, height: 1256 },
  "images/about/wa-flag-hero.webp": { width: 1920, height: 1319 },
  "images/about/wa-homeowners-know.webp": { width: 1280, height: 1920 },
  "images/about/wa-photo-1.webp": { width: 1920, height: 1178 },
  "images/about/wa-photo-2.webp": { width: 1920, height: 1280 },
  "images/about/wa-photo-3.webp": { width: 1920, height: 1280 },
  "images/about/wa-photo-4.webp": { width: 1920, height: 1166 },
  "images/about/wa-photo-5.webp": { width: 1440, height: 1920 },
  "images/about/wa-photo-6.webp": { width: 1920, height: 1440 },
  "images/about/where-we-serve-hero.webp": { width: 1824, height: 1207 },
  "images/al-flag.webp": { width: 1000, height: 1000 },
  "images/arrow-yellow.webp": { width: 172, height: 68 },
  "images/auto-insurance-panorama.webp": { width: 1920, height: 424 },
  "images/az-flag.webp": { width: 1000, height: 1000 },
  "images/blog/A1-scaled.webp": { width: 973, height: 2560 },
  "images/blog/A2-1-scaled.webp": { width: 1525, height: 2560 },
  "images/blog/A2.webp": { width: 1600, height: 2262 },
  "images/blog/A3-scaled.webp": { width: 1072, height: 2560 },
  "images/blog/AdobeStock_1002675663-1024x574.webp": { width: 1024, height: 574 },
  "images/blog/AdobeStock_1003878517-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_100734575-1024x683.webp": { width: 1024, height: 683 },
  "images/blog/AdobeStock_100734575-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_1094185529-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_1096903008-1024x574.webp": { width: 1024, height: 574 },
  "images/blog/AdobeStock_110292817-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_1151772251-1024x576.webp": { width: 1024, height: 576 },
  "images/blog/AdobeStock_1190487544-scaled.webp": { width: 2560, height: 1435 },
  "images/blog/AdobeStock_123091886-scaled.webp": { width: 2560, height: 1438 },
  "images/blog/AdobeStock_1238534425-1-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_126616293-scaled.webp": { width: 2560, height: 1702 },
  "images/blog/AdobeStock_1347479352-scaled.webp": { width: 2560, height: 1280 },
  "images/blog/AdobeStock_1359313959-scaled.webp": { width: 2560, height: 1435 },
  "images/blog/AdobeStock_1462585165-scaled.webp": { width: 2560, height: 1435 },
  "images/blog/AdobeStock_1470642828-scaled.webp": { width: 2560, height: 1664 },
  "images/blog/AdobeStock_153406782-1024x683.webp": { width: 1024, height: 683 },
  "images/blog/AdobeStock_1541314493-scaled.webp": { width: 2560, height: 1350 },
  "images/blog/AdobeStock_171085827-1-1024x683.webp": { width: 1024, height: 683 },
  "images/blog/AdobeStock_185592300-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_200002294-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_267253482-1024x683.webp": { width: 1024, height: 683 },
  "images/blog/AdobeStock_267253482-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_270489261-scaled.webp": { width: 2560, height: 1709 },
  "images/blog/AdobeStock_29977022-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_306405090-scaled.webp": { width: 2560, height: 1440 },
  "images/blog/AdobeStock_379428893-1024x683.webp": { width: 1024, height: 683 },
  "images/blog/AdobeStock_403242500-1-1024x683.webp": { width: 1024, height: 683 },
  "images/blog/AdobeStock_423518457-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_428391843-1024x683.webp": { width: 1024, height: 683 },
  "images/blog/AdobeStock_433370917-1024x683.webp": { width: 1024, height: 683 },
  "images/blog/AdobeStock_433370917-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_437903717-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_440526331-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_442416575-1024x576.webp": { width: 1024, height: 576 },
  "images/blog/AdobeStock_445654541-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_464325714-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_497008264-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_528320298-1024x683.webp": { width: 1024, height: 683 },
  "images/blog/AdobeStock_555123615-scaled.webp": { width: 2560, height: 1440 },
  "images/blog/AdobeStock_592961162-scaled.webp": { width: 2560, height: 1435 },
  "images/blog/AdobeStock_647004426-scaled.webp": { width: 2560, height: 1463 },
  "images/blog/AdobeStock_647303331-1024x683.webp": { width: 1024, height: 683 },
  "images/blog/AdobeStock_73360365-1-1024x690.webp": { width: 1024, height: 690 },
  "images/blog/AdobeStock_776337973-scaled.webp": { width: 2560, height: 1097 },
  "images/blog/AdobeStock_85255540-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/AdobeStock_93328664-scaled.webp": { width: 2560, height: 1707 },
  "images/blog/Asset-3.webp": { width: 1600, height: 1588 },
  "images/blog/ChatGPT-Image-Mar-28-2025-05_05_17-PM.webp": { width: 1536, height: 1024 },
  "images/blog/Guardian-Service-Logo-Blue-Shield-Only.webp": { width: 200, height: 200 },
  "images/blog/HD_1980x1080-2-scaled.webp": { width: 2560, height: 1440 },
  "images/blog/HD_1980x1080-scaled.webp": { width: 2560, height: 1440 },
  "images/blog/HD_1980x1080-v2.webp": { width: 1920, height: 1081 },
  "images/blog/HD_1980x1080.webp": { width: 2560, height: 1440 },
  "images/blog/Header-1980x1080-1-scaled.webp": { width: 2560, height: 1397 },
  "images/blog/Homeowners-insurance-awareness-header.webp": { width: 1920, height: 1080 },
  "images/blog/Untitled-design-819x1024.webp": { width: 819, height: 1024 },
  "images/blog/What-home-insurance-premiums-will-look-like-starting-June-1.-versus-what-they-could-have-been.webp": { width: 939, height: 581 },
  "images/blog/a1-homeowners_havent_read-.webp": { width: 1600, height: 1904 },
  "images/blog/a2-couldnt_afford_pay-1.webp": { width: 1600, height: 2410 },
  "images/blog/a3-homeowner_insurance_quiz.webp": { width: 1600, height: 5106 },
  "images/blog/ai-and-home-insurance.webp": { width: 1600, height: 2336 },
  "images/blog/auto_insurance_policyholders.webp": { width: 1600, height: 2550 },
  "images/blog/big_purachse_delays-scaled.webp": { width: 819, height: 2560 },
  "images/blog/biggest-regrets-3.webp": { width: 1600, height: 2446 },
  "images/blog/common_emotions.webp": { width: 1600, height: 2660 },
  "images/blog/cost-of-clogged-pipes.webp": { width: 1600, height: 2374 },
  "images/blog/delaying-a-plumbing-repair.webp": { width: 1600, height: 1720 },
  "images/blog/economic-uncertainty-delaying-home-upgrades.webp": { width: 1000, height: 467 },
  "images/blog/example-underinsured-screenshot.webp": { width: 1024, height: 279 },
  "images/blog/experiencing-buyers-remorse-2.webp": { width: 1600, height: 2446 },
  "images/blog/financial-pitfalls-homebuyers.webp": { width: 1600, height: 1858 },
  "images/blog/header-first-time-homebuyers-nightmare.webp": { width: 1920, height: 1080 },
  "images/blog/header-flushed-funds-report.webp": { width: 2560, height: 1440 },
  "images/blog/header_image-1-scaled.webp": { width: 2560, height: 1442 },
  "images/blog/homebuyer-budgets.webp": { width: 1600, height: 884 },
  "images/blog/insurance-cost-comparison-1024x515.webp": { width: 1024, height: 515 },
  "images/blog/insurance-coverage.webp": { width: 1600, height: 2296 },
  "images/blog/insurance-eligibility-at-risk-scaled.webp": { width: 1542, height: 2560 },
  "images/blog/kara-circle-819x1024.webp": { width: 819, height: 1024 },
  "images/blog/knowledge-gap.webp": { width: 1600, height: 2158 },
  "images/blog/logic-emotions-when-buying-home-3.webp": { width: 1600, height: 1284 },
  "images/blog/most-common-plumbing-issues.webp": { width: 1600, height: 2422 },
  "images/blog/primary-perception-of-home.webp": { width: 1600, height: 760 },
  "images/blog/recommend-tesla.webp": { width: 1600, height: 2038 },
  "images/blog/reducing_insurance_to_save-scaled.webp": { width: 1035, height: 2560 },
  "images/blog/renovation-recession-scaled.webp": { width: 980, height: 2560 },
  "images/blog/rising_insurance_costs.webp": { width: 1600, height: 2976 },
  "images/blog/sam-circle-819x1024.webp": { width: 819, height: 1024 },
  "images/blog/saving-in-home-renovations-with-ai.webp": { width: 1600, height: 2082 },
  "images/blog/scratched_smashed-_HD-3.webp": { width: 1920, height: 1080 },
  "images/blog/switchin_usage-based_insurance.webp": { width: 1600, height: 1990 },
  "images/blog/taelor-circle-819x1024.webp": { width: 819, height: 1024 },
  "images/blog/truth-about-flushing.webp": { width: 1600, height: 3082 },
  "images/blog/upgrade-payoff-scaled.webp": { width: 1156, height: 2560 },
  "images/blog/vandalism-experience-.webp": { width: 1600, height: 2454 },
  "images/blog/views_on_insurance.webp": { width: 1608, height: 2001 },
  "images/blog/what-homeowners-ask-ai-scaled.webp": { width: 987, height: 2560 },
  "images/blog/who-do-you-trust-for-advice-scaled.webp": { width: 1450, height: 2560 },
  "images/building-home-habitat.webp": { width: 1920, height: 1210 },
  "images/bundle-discount-graphic.webp": { width: 1700, height: 1288 },
  "images/bundle-graphic-mobile.webp": { width: 1544, height: 910 },
  "images/buy-by-phone-graphic.webp": { width: 1070, height: 1024 },
  "images/buy-by-phone-mobile.webp": { width: 1070, height: 1024 },
  "images/calendar-convenience-bg.webp": { width: 1920, height: 768 },
  "images/call-forward/AMZ_Gift_Card-2.webp": { width: 1035, height: 684 },
  "images/call-forward/Gift_Card_Icon-2.webp": { width: 1920, height: 1252 },
  "images/call-forward/MMM_Call_Hero_Image.webp": { width: 1100, height: 1061 },
  "images/call-forward/Phone_Icon.webp": { width: 1914, height: 1920 },
  "images/call-forward/Step_2_Icon_-_thicker.webp": { width: 1187, height: 1199 },
  "images/car-image-1.webp": { width: 1824, height: 1824 },
  "images/car-image-2.webp": { width: 1929, height: 1929 },
  "images/car-image-3.webp": { width: 1824, height: 1824 },
  "images/careers/Shield - Alexis Lopez.webp": { width: 1000, height: 1243 },
  "images/careers/Shield - Ana Berrizbeitia.webp": { width: 1000, height: 1259 },
  "images/careers/Shield - Daniel T.webp": { width: 1000, height: 1243 },
  "images/careers/Shield - Diane Marrero.webp": { width: 1000, height: 1243 },
  "images/careers/Shield - Emma Reid.webp": { width: 1000, height: 1259 },
  "images/careers/Shield - Jerrica Medina.webp": { width: 1000, height: 1243 },
  "images/careers/Shield - Joey Felix.webp": { width: 1000, height: 1243 },
  "images/careers/Shield - Julian L.webp": { width: 1000, height: 1259 },
  "images/careers/Shield - Meena Kaundinya.webp": { width: 1000, height: 1259 },
  "images/careers/Shield - Minda Flores.webp": { width: 1000, height: 1259 },
  "images/careers/Shield - Rachel Kelsey.webp": { width: 1000, height: 1259 },
  "images/careers/Shield - Robbie O.webp": { width: 1000, height: 1259 },
  "images/careers/Shield - Shawn Terrell.webp": { width: 1000, height: 1259 },
  "images/careers/Shield - Shivalika Chaudhary.webp": { width: 1000, height: 1259 },
  "images/careers/Shield - Tim F.webp": { width: 1000, height: 1259 },
  "images/careers/adriana-avatar-new.webp": { width: 1544, height: 1920 },
  "images/careers/amanda-m-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/andrea-avatar-new.webp": { width: 1544, height: 1920 },
  "images/careers/anthony-spinasanto-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/brandon-sizemore-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/brian-aga-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/eric-avatar-new.webp": { width: 1544, height: 1920 },
  "images/careers/frankie-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/jacinda-q-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/jeremy-avatar-new.webp": { width: 1544, height: 1920 },
  "images/careers/jessica-avatar-new.webp": { width: 1544, height: 1920 },
  "images/careers/jonathan-avatar-new.webp": { width: 1544, height: 1920 },
  "images/careers/jorge-o-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/katie-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/kristi-avatar-new.webp": { width: 1544, height: 1920 },
  "images/careers/laura-avatar-new.webp": { width: 1544, height: 1920 },
  "images/careers/linh-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/matthew-avatar-new.webp": { width: 1544, height: 1920 },
  "images/careers/meet-our-agents-hero-new-3.webp": { width: 1920, height: 592 },
  "images/careers/meet-our-agents-new.webp": { width: 1920, height: 592 },
  "images/careers/melissa-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/nate-brown-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/omar-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/reid-beer-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/sabrina-clark-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/sarah-avatar-new.webp": { width: 1544, height: 1920 },
  "images/careers/seth-walden-avatar.webp": { width: 500, height: 622 },
  "images/careers/sophie-bryant-avatar.webp": { width: 500, height: 622 },
  "images/careers/steve-avatar.webp": { width: 1544, height: 1920 },
  "images/careers/tessa-b-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/testimonial-andrea-tysor.webp": { width: 1645, height: 1824 },
  "images/careers/testimonial-anthony-spinasanto.webp": { width: 700, height: 926 },
  "images/careers/testimonial-eric-bushey.webp": { width: 1356, height: 1920 },
  "images/careers/testimonial-jeremy-lifestyle.webp": { width: 1352, height: 1920 },
  "images/careers/testimonial-jorge-ortiz.webp": { width: 500, height: 667 },
  "images/careers/testimonial-laura-lifestyle.webp": { width: 1439, height: 1920 },
  "images/careers/testimonial-nate-brown.webp": { width: 500, height: 667 },
  "images/careers/testimonial-tessa-b.webp": { width: 500, height: 871 },
  "images/careers/testimonial-tyson-lifestyle.webp": { width: 1440, height: 1920 },
  "images/careers/testimonial-wayne-cruz.webp": { width: 480, height: 640 },
  "images/careers/thomas-m-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/trinh-tran-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/tyson-avatar.webp": { width: 1000, height: 1243 },
  "images/careers/wayne-c-avatar.webp": { width: 1000, height: 1243 },
  "images/carrier-comparison-design.webp": { width: 1920, height: 1515 },
  "images/carrier-comparison-mobile.webp": { width: 1700, height: 1288 },
  "images/carriers/aaa-office.webp": { width: 500, height: 500 },
  "images/carriers/aig-office.webp": { width: 500, height: 500 },
  "images/carriers/allstate-office.webp": { width: 400, height: 400 },
  "images/carriers/american-modern-office.webp": { width: 400, height: 400 },
  "images/carriers/amwins-office.webp": { width: 400, height: 400 },
  "images/carriers/branch-office.webp": { width: 633, height: 633 },
  "images/carriers/chubb-office.webp": { width: 400, height: 400 },
  "images/carriers/crc-group-office.webp": { width: 400, height: 400 },
  "images/carriers/farmers-office.webp": { width: 400, height: 400 },
  "images/carriers/foremost-office.webp": { width: 400, height: 400 },
  "images/carriers/frontline-office.webp": { width: 400, height: 400 },
  "images/carriers/geico-office.webp": { width: 400, height: 400 },
  "images/carriers/grange-office.webp": { width: 420, height: 420 },
  "images/carriers/hagerty-office.webp": { width: 400, height: 400 },
  "images/carriers/jewelers-mutual-office.webp": { width: 400, height: 400 },
  "images/carriers/liberty-mutual-office.webp": { width: 400, height: 400 },
  "images/carriers/mapfre-office.webp": { width: 493, height: 493 },
  "images/carriers/mercury-insurance-office.webp": { width: 574, height: 561 },
  "images/carriers/mutual-of-enumclaw-office.webp": { width: 360, height: 360 },
  "images/carriers/national-general-office.webp": { width: 400, height: 400 },
  "images/carriers/nationwide-office.webp": { width: 400, height: 400 },
  "images/carriers/neptune-office.webp": { width: 400, height: 400 },
  "images/carriers/orion180-office.webp": { width: 400, height: 400 },
  "images/carriers/palomar-office.webp": { width: 580, height: 580 },
  "images/carriers/penn-national-office.webp": { width: 500, height: 500 },
  "images/carriers/plymouth-rock-office.webp": { width: 400, height: 400 },
  "images/carriers/progressive-office.webp": { width: 400, height: 400 },
  "images/carriers/pure-insurance.webp": { width: 400, height: 400 },
  "images/carriers/root-office.webp": { width: 400, height: 400 },
  "images/carriers/safeco-office.webp": { width: 392, height: 392 },
  "images/carriers/shelter-office.webp": { width: 500, height: 500 },
  "images/carriers/stillwater-office.webp": { width: 400, height: 400 },
  "images/carriers/the-general-office.webp": { width: 400, height: 400 },
  "images/carriers/the-hartford-office.webp": { width: 400, height: 400 },
  "images/carriers/travelers-office.webp": { width: 500, height: 500 },
  "images/carriers/universal-property-office.webp": { width: 400, height: 400 },
  "images/carriers/west-bend-office.webp": { width: 500, height: 500 },
  "images/carriers/westfield-office.webp": { width: 475, height: 475 },
  "images/check-circle-blue-icon.webp": { width: 74, height: 74 },
  "images/choice-section-bg.webp": { width: 1920, height: 669 },
  "images/co-flag.webp": { width: 1000, height: 1000 },
  "images/contact-hero-new.webp": { width: 1920, height: 661 },
  "images/contact/contact-block-1.webp": { width: 1824, height: 1824 },
  "images/contact/contact-block-2.webp": { width: 1824, height: 1824 },
  "images/contact/contact-block-3.webp": { width: 1824, height: 1824 },
  "images/contact/contact-hero-white-wall-2.webp": { width: 1920, height: 652 },
  "images/cork-board-wall-photo.webp": { width: 1320, height: 1320 },
  "images/corner-shield.webp": { width: 1144, height: 1462 },
  "images/coverage-check/claims/A1_south-tucson_01_leak-surface.webp": { width: 720, height: 960 },
  "images/coverage-check/claims/A1_south-tucson_02_pipe-break.webp": { width: 720, height: 960 },
  "images/coverage-check/claims/A1_south-tucson_03_repaired.webp": { width: 720, height: 960 },
  "images/coverage-check/claims/A2_conyers-ga_01_roots-at-joint.webp": { width: 720, height: 960 },
  "images/coverage-check/claims/A2_conyers-ga_02_roots-in-pipe-videostill.webp": { width: 720, height: 1048 },
  "images/coverage-check/gainesville_12.webp": { width: 700, height: 388 },
  "images/coverage-check/repair_trench_excavator.webp": { width: 720, height: 960 },
  "images/coverage-check/repair_trench_farmhouse.webp": { width: 720, height: 960 },
  "images/coverage-check/repair_trench_lawn.webp": { width: 800, height: 1067 },
  "images/coverage-check/responsibility_diagram.webp": { width: 745, height: 1000 },
  "images/ct-flag.webp": { width: 1000, height: 1000 },
  "images/customer-estelle-new.JPEG": { width: 733, height: 733 },
  "images/customer-estelle-new.webp": { width: 733, height: 733 },
  "images/customer-estelle.webp": { width: 1920, height: 1920 },
  "images/farmers-logo.webp": { width: 1920, height: 411 },
  "images/flags/al-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/al-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/az-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/az-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/co-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/co-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/ct-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/ct-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/ga-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/ga-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/in-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/in-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/ky-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/ky-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/md-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/md-flag-hero.webp": { width: 700, height: 700 },
  "images/flags/mn-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/mn-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/mo-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/mo-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/ms-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/ms-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/nc-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/nc-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/nj-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/nj-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/nm-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/nm-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/nv-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/nv-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/oh-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/oh-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/or-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/or-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/pa-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/pa-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/sc-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/sc-flag-hero.webp": { width: 700, height: 700 },
  "images/flags/tn-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/tn-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/tx-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/tx-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/ut-flag-hero-mobile.webp": { width: 700, height: 700 },
  "images/flags/ut-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/va-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/va-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flags/wa-flag-hero-mobile.webp": { width: 1000, height: 1000 },
  "images/flags/wa-flag-hero.webp": { width: 1000, height: 1000 },
  "images/flipping-pyramid-v2.webp": { width: 1920, height: 1118 },
  "images/frontline-mindset-new.webp": { width: 1920, height: 1280 },
  "images/frontline-mindset.webp": { width: 1920, height: 1280 },
  "images/ga-flag.webp": { width: 1000, height: 1000 },
  "images/girl-with-cap.jpg": { width: 437, height: 437 },
  "images/girl-with-cap.webp": { width: 437, height: 437 },
  "images/google-reviews.webp": { width: 769, height: 431 },
  "images/hero-auto-insurance-v2.webp": { width: 1920, height: 592 },
  "images/hero-bg-light-blue-gradient.webp": { width: 1277, height: 1920 },
  "images/hero-cheap-home.webp": { width: 1290, height: 860 },
  "images/hero-home-insurance-v3.webp": { width: 1920, height: 592 },
  "images/hero-new.webp": { width: 1536, height: 1024 },
  "images/hero-team-image.jpg": { width: 1920, height: 1920 },
  "images/hero-team-image.webp": { width: 1920, height: 1920 },
  "images/hero-utility-line-warranty.webp": { width: 1920, height: 592 },
  "images/hiw1.png": { width: 537, height: 668 },
  "images/hiw1.webp": { width: 537, height: 668 },
  "images/hiw2.png": { width: 537, height: 668 },
  "images/hiw2.webp": { width: 537, height: 668 },
  "images/hiw3.png": { width: 537, height: 668 },
  "images/hiw3.webp": { width: 537, height: 668 },
  "images/home-block-1-new.webp": { width: 817, height: 817 },
  "images/home-block-2-new.webp": { width: 616, height: 616 },
  "images/home-block-3-updated.webp": { width: 428, height: 428 },
  "images/home-illustration-shield.webp": { width: 1920, height: 752 },
  "images/home-review-new-1.webp": { width: 428, height: 428 },
  "images/home-review-new-10.webp": { width: 576, height: 576 },
  "images/home-review-new-2.webp": { width: 913, height: 679 },
  "images/home-review-new-3.webp": { width: 919, height: 685 },
  "images/home-review-new-4.webp": { width: 1288, height: 817 },
  "images/home-review-new-5.webp": { width: 930, height: 616 },
  "images/home-review-new-6.webp": { width: 916, height: 691 },
  "images/home-review-new-7.webp": { width: 576, height: 576 },
  "images/home-review-new-8.webp": { width: 480, height: 480 },
  "images/home-review-new-9.webp": { width: 864, height: 864 },
  "images/how-it-works-hero-new.webp": { width: 1996, height: 796 },
  "images/how-it-works-we-shop.webp": { width: 1000, height: 1243 },
  "images/icon-get-covered.webp": { width: 425, height: 413 },
  "images/icon-repairs-done.webp": { width: 663, height: 404 },
  "images/icon-submit-claim.webp": { width: 450, height: 392 },
  "images/insurance/hero-specialty-insurance.webp": { width: 1920, height: 592 },
  "images/insurance/meet-our-agents-hero-updated.webp": { width: 1920, height: 822 },
  "images/invite-final-cta-shield-gray.webp": { width: 505, height: 623 },
  "images/invite-hero-welcome-mat.webp": { width: 1024, height: 1024 },
  "images/invite-hiw1.webp": { width: 1920, height: 761 },
  "images/invite-hiw2.webp": { width: 1536, height: 1024 },
  "images/invite-hiw3.webp": { width: 1632, height: 640 },
  "images/invite-member-benefits-house-line.webp": { width: 1799, height: 636 },
  "images/invite-value-shield-checkmark-blue.webp": { width: 624, height: 635 },
  "images/jewelry-hero.webp": { width: 1920, height: 592 },
  "images/jewelry-insurance-banner.webp": { width: 2000, height: 738 },
  "images/join-us-full-width.webp": { width: 1920, height: 431 },
  "images/join-us-hero.webp": { width: 1920, height: 652 },
  "images/join-us-image-1.webp": { width: 1824, height: 1824 },
  "images/join-us-image-2.webp": { width: 1824, height: 1824 },
  "images/join-us-image-3.webp": { width: 1824, height: 1824 },
  "images/kara-event.jpg": { width: 614, height: 451 },
  "images/kara-event.webp": { width: 614, height: 451 },
  "images/property-tax/hero-home-golden-shield.webp": { width: 1536, height: 1024 },
  "images/property-tax/hero-home.webp": { width: 1200, height: 796 },
  "images/kyshawn-photo.webp": { width: 456, height: 445 },
  "images/kyshawn_gs_polo_desktop.webp": { width: 700, height: 933 },
  "images/kyshawn_gs_polo_mobile.webp": { width: 1000, height: 781 },
  "images/liberty-mutual-logo.webp": { width: 1920, height: 527 },
  "images/life-at-guardian-hero.webp": { width: 1920, height: 628 },
  "images/life-slideshow-new-1.jpg": { width: 1920, height: 1440 },
  "images/life-slideshow-new-1.webp": { width: 1920, height: 1440 },
  "images/life-slideshow-new-10.webp": { width: 1920, height: 1280 },
  "images/life-slideshow-new-11.webp": { width: 1920, height: 1104 },
  "images/life-slideshow-new-12.webp": { width: 1920, height: 1178 },
  "images/life-slideshow-new-13.webp": { width: 1920, height: 998 },
  "images/life-slideshow-new-14.webp": { width: 1920, height: 1124 },
  "images/life-slideshow-new-15.webp": { width: 1920, height: 1440 },
  "images/life-slideshow-new-16.webp": { width: 1824, height: 1368 },
  "images/life-slideshow-new-17.webp": { width: 1824, height: 1368 },
  "images/life-slideshow-new-18.webp": { width: 1920, height: 1440 },
  "images/life-slideshow-new-19.webp": { width: 4080, height: 3072 },
  "images/life-slideshow-new-2.webp": { width: 1920, height: 1440 },
  "images/life-slideshow-new-20.webp": { width: 4032, height: 3024 },
  "images/life-slideshow-new-21.webp": { width: 5712, height: 4284 },
  "images/life-slideshow-new-22.webp": { width: 5712, height: 4284 },
  "images/life-slideshow-new-23.webp": { width: 1000, height: 750 },
  "images/life-slideshow-new-24.webp": { width: 1000, height: 506 },
  "images/life-slideshow-new-25.webp": { width: 1000, height: 531 },
  "images/life-slideshow-new-3.webp": { width: 1920, height: 1280 },
  "images/life-slideshow-new-4.webp": { width: 1920, height: 1280 },
  "images/life-slideshow-new-5.webp": { width: 1920, height: 1280 },
  "images/life-slideshow-new-6.webp": { width: 1920, height: 1280 },
  "images/life-slideshow-new-7.webp": { width: 1920, height: 1280 },
  "images/life-slideshow-new-8.webp": { width: 1824, height: 1216 },
  "images/life-slideshow-new-9.webp": { width: 1824, height: 1216 },
  "images/location-pin-blue.webp": { width: 45, height: 70 },
  "images/marketplace-reshopping.webp": { width: 1920, height: 1528 },
  "images/matching-employees.webp": { width: 1920, height: 1213 },
  "images/md-flag.webp": { width: 700, height: 700 },
  "images/nc-flag-hero-mobile.webp": { width: 1277, height: 1920 },
  "images/nc-flag-hero.webp": { width: 1277, height: 1920 },
  "images/next-steps-andrea-tysor.webp": { width: 999, height: 1000 },
  "images/next-steps-katie-rohde.webp": { width: 1000, height: 1000 },
  "images/next-steps-thomas-mclaughlin.webp": { width: 1000, height: 1000 },
  "images/nonprofit-board-leadership.webp": { width: 1920, height: 1440 },
  "images/partnerships/partnerships-hero.webp": { width: 1920, height: 761 },
  "images/providing-comfort.jpg": { width: 1920, height: 1079 },
  "images/providing-comfort.webp": { width: 1920, height: 1079 },
  "images/root-logo.webp": { width: 4107, height: 1234 },
  "images/row-of-houses-fullwidth.webp": { width: 1920, height: 424 },
  "images/sc-flag.webp": { width: 700, height: 700 },
  "images/shop-rates/New Hero Image - Older Demo.webp": { width: 1200, height: 1295 },
  "images/shop-rates/hero-bg-light-blue-gradient.webp": { width: 1920, height: 800 },
  "images/shop-rates/hero-image-new.webp": { width: 1778, height: 1920 },
  "images/shop-rates/hero-phone-mobile.webp": { width: 996, height: 1920 },
  "images/specialty-boat.webp": { width: 912, height: 912 },
  "images/specialty-condo.webp": { width: 912, height: 912 },
  "images/specialty-motorcycle.webp": { width: 912, height: 912 },
  "images/specialty-rv-fullwidth.webp": { width: 1920, height: 424 },
  "images/stack-of-cash.png": { width: 150, height: 100 },
  "images/stack-of-cash.webp": { width: 150, height: 100 },
  "images/testimonial-Debbie.jpeg": { width: 756, height: 1008 },
  "images/testimonial-Debbie.webp": { width: 756, height: 1008 },
  "images/testimonial-headshot-allen-foster.webp": { width: 148, height: 148 },
  "images/testimonial-headshot-kyle-patterson.webp": { width: 500, height: 500 },
  "images/testimonial-headshot-lauren-prosser.webp": { width: 204, height: 204 },
  "images/testimonial-headshot-molly-oconnor.webp": { width: 286, height: 286 },
  "images/testimonial-katie-rhode.webp": { width: 1000, height: 1242 },
  "images/testimonial-michael.png": { width: 756, height: 761 },
  "images/testimonial-michael.webp": { width: 756, height: 761 },
  "images/testimonial-photo-allen-foster.webp": { width: 677, height: 679 },
  "images/testimonial-photo-kyle-patterson.webp": { width: 1200, height: 1200 },
  "images/testimonial-photo-lauren-prosser.webp": { width: 1200, height: 1195 },
  "images/testimonial-photo-molly-oconnor.webp": { width: 1224, height: 1282 },
  "images/testimonial-sontice.jpg": { width: 817, height: 817 },
  "images/testimonial-sontice.webp": { width: 817, height: 817 },
  "images/tn-flag.webp": { width: 1000, height: 1000 },
  "images/trustpilot-excellent.webp": { width: 1065, height: 133 },
  "images/trustpilot-mobile.webp": { width: 1310, height: 159 },
  "images/ulw-clogs-blockages.webp": { width: 800, height: 533 },
  "images/ulw-feature-block-3.webp": { width: 428, height: 428 },
  "images/ulw-ground-settling.webp": { width: 800, height: 533 },
  "images/ulw-infographic.webp": { width: 1200, height: 1610 },
  "images/ulw-local-professionals.webp": { width: 1191, height: 673 },
  "images/ulw-national-expertise.webp": { width: 1194, height: 675 },
  "images/ulw-old-pipes.webp": { width: 800, height: 533 },
  "images/ulw-responsive-service.webp": { width: 1200, height: 678 },
  "images/ulw-rodents.webp": { width: 800, height: 533 },
  "images/ulw-tree-roots.webp": { width: 800, height: 533 },
  "images/ulw-weather-conditions.webp": { width: 800, height: 533 },
  "images/umbrella-hero.webp": { width: 1920, height: 592 },
  "images/umbrella-insurance-banner.webp": { width: 1920, height: 640 },
  "images/underline-2.webp": { width: 388, height: 58 },
  "images/underline-navy.webp": { width: 391, height: 64 },
  "images/underline-white.webp": { width: 388, height: 58 },
  "images/v2 Hero Image - Auto Insurance.jpg": { width: 9125, height: 2817 },
  "images/v2 Hero Image - Auto Insurance.webp": { width: 1920, height: 593 },
  "images/v2 Hero Image - Home Insurance.jpg": { width: 9125, height: 2817 },
  "images/v2 Hero Image - Home Insurance.webp": { width: 1920, height: 593 },
  "images/v2 Hero Image - Specialty Insurance.jpg": { width: 9125, height: 2817 },
  "images/v2 Hero Image - Specialty Insurance.webp": { width: 1920, height: 593 },
  "images/v2 Hero Image - ULW.jpg": { width: 9125, height: 2817 },
  "images/v2 Hero Image - ULW.webp": { width: 1920, height: 593 },
  "images/va-flag.webp": { width: 1000, height: 1000 },
  "images/white-shield.webp": { width: 506, height: 635 },
} as const;
